import React from "react";
import style from "./workingFile.module.scss";
import Header from "./Header";
import Footer from "./Footer";
import { dateFormateDD, formatAmountCalculate } from "../../utility";

function Main({ Content }) {
  return (
    <>
      <div className={style.invoiceContainer}>
        <div className={style.invoiceItems}>
          <table>
            <thead>
              <tr>
                <th>Description</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr className={`${style.Recruitment}`}>
                <td
                  colSpan={2}
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Recruitment charges
                </td>
              </tr>
              {Content.map((item, index) => (
                <>
                  <tr key={index}>
                    <td
                      style={{
                        textAlign: "left",
                        fontWeight: "bold",
                        // paddingBottom: "12px",
                      }}
                    >
                      {`${item.name} ${
                        item.employeeId ? "|" + " " + item.employeeId : ""
                      } ${
                        item.department ? "|" + " " + item.department : ""
                      }   |  ${item.category}`}
                      <div style={{ marginTop: "8px", fontWeight: "normal" }}>
                        <span>
                          Date of Joining: {dateFormateDD(item.joined)}
                        </span>
                      </div>
                    </td>
                    <td style={{ fontSize: "14px" }}>
                      ₹{formatAmountCalculate(item.ctc)}
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Main;
//  {`${item.name} ${
//                       item.employeeId ? "|" + item.employeeId : ""
//                     }   |  ${item.category}`}
//                     <div style={{ marginTop: "8px", fontWeight: "normal" }}>
//                       <span>Date of Joining: {dateFormateDD(item.joined)}</span>
//                     </div>
//                   </td>
//                   <td style={{ fontSize: "15px" }}>{item.ctc}</td>
